<template>
  <div :class="{'bg-gray30': isEducation}">
    <account-header/>
    <transition name="fade" mode="out-in">
      <router-view class="container p-x-1:mo m-b-3 m-b-6:t" />
    </transition>
  </div>
</template>

<script>
import AccountHeader from './components/AccountHeader';

export default {
  name: 'pro-account',
  components: {
    AccountHeader,
  },
  data () {
    return {
      isEducation: false,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler (val) {
        if (!this.$device.isMobile) {
          const pathValues = val.path.split('/');
          this.isEducation = pathValues.some(v => ['education', 'video', 'quiz'].indexOf(v) >= 0);
        }
      },
    },
  },
  mounted () {
    this.$store.dispatch('account/pro/fetch');
  },
};
</script>
